<template>
    <div class="container bankBossAudit" v-if="isVisible" style="z-index:1">
        <div class="bankAuditDialog">
            <el-row>
                <el-col :span="24">
                    <div class="bankAuditHeader">
                        <div class="bankAuditHeaderName">审核详情</div>
                        <div class="bankAuditHeaderClose" title="关闭" @click="onChangeClose">×</div>
                    </div>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName">
                <el-tab-pane label="审核信息" name="second" v-if="auditShow">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    申请信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">姓名：{{flowInfo.Name}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">身份证号：{{flowInfo.IdNum}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">联系方式：{{flowInfo.Phone}}</div>
                            </el-col>
                            <el-col :span="8" >
                                <div class="viewText">申请者：{{flowInfo.PersonCompanyFlag
                                =='company'?"公司":"个人"}}</div>
                            </el-col>
                            <el-col :span="8" v-if="flowInfo.PersonCompanyFlag==='company'">
                                <div class="viewText">公司名称：{{flowInfo.PersonCompanyText}}</div>
                            </el-col>
                            <el-col :span="8" v-if="flowInfo.PersonCompanyFlag==='company'">
                                <div class="viewText">营业执照：{{flowInfo.PersonCompanyKey}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">申请金额：{{flowInfo.Money}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">银行：{{flowInfo.FullBankChooseText}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">申请时间：{{flowInfo.CreateTime}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">主营业务：{{flowInfo.FirstBusiness}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">{{secondBusinessTitle}}：{{flowInfo.SecondBusiness}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">类型：{{flowInfo.LoanName}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">资产总额：{{flowInfo.TotalAssets}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">资产负债率：{{flowInfo.AssetCoverage}}%</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年营业收入：{{flowInfo.LastYearIncome}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年税收：{{flowInfo.LastYearTax}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年利润：{{flowInfo.LastYearProfit}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">从业人数：{{flowInfo.PeopleCount}}人</div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    预授信信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-if="loanAudit.PreCredit" class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">预授信：{{loanAudit.PreCredit}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">录入人：{{loanAudit.UpdateUserName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">时间：{{loanAudit.UpdateTime}}</div>
                            </el-col>
                        </el-row>
                        <el-row v-else-if="areascorelist[2]" class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">预授信：{{areascorelist[2]}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">年龄：{{areascorelist[0]}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">土地面积(亩)：{{areascorelist[1]}}</div>
                            </el-col>
                        </el-row>
                        <!-- <el-row v-else class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">无数据</div>
                            </el-col>
                        </el-row> -->
                         <el-row>
                                    <el-button style="margin:8px auto 8px auto;" class="button-new-tag" size="small" @click="addScore">+ 新增</el-button>
                                </el-row>
                         <el-row v-if="newObj">
                                    <el-col :span="3">
                                        <div class="bankAuditLB">资产总额（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                            @change="changeHknl2"
                                                v-model="newObj.TotalAssets"
                                                size="small"
                                                placeholder="请输入资产总额（万元）">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB" >资产负债率（%）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                               @change="changeAssetCoverage"
                                                v-model="newObj.AssetCoverage"
                                                size="small"
                                                placeholder="请输入资产负债率）">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年营业收入（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                               @change="changeHknl2"
                                                v-model="newObj.LastYearIncome"
                                                size="small"
                                                placeholder="请输入上年营业收入（万元）">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年利润（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                                v-model="newObj.LastYearProfit"
                                                size="small"
                                                placeholder="请输入上年利润（万元）">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年税收（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                            :disabled="disabled"
                                                v-model="newObj.LastYearTax"
                                                size="small"
                                                placeholder="请输入上年税收（万元）"
                                                @change="onGetScore">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">从业人数：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent" > 
                                            <el-input
                                            :disabled="disabled"
                                                v-model="newObj.PeopleCount"
                                                size="small"
                                                placeholder="请输入从业人数">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                            </el-row>
                         <el-row v-if="newObj">
                                <el-col :span="3">
                                        <div class="bankAuditLB">征信记录：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select v-model="newObj.xyzk_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">征信查询:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select v-model="newObj.xyzk_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">诉讼及执行情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select v-model="newObj.xyzk_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">借款人稳定性：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select v-model="newObj.xyzk_value4" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">企业经营情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select v-model="newObj.xyzk_value5" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in xyzk_list5"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row v-if="newObj">
                                <el-col :span="3">
                                        <div class="bankAuditLB">财务状况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent" > 
                                            <el-select disabled v-model="newObj.hknl_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">收入及现金流:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select v-model="newObj.hknl_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">抵押物价值：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select v-model="newObj.hknl_value3" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in hknl_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row v-if="newObj" >
                                <el-col :span="3">
                                        <div class="bankAuditLB">担保人信用及能力：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select v-model="newObj.dbcs_value1" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保方式及风险:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="newObj.dbcs_value2" placeholder="请选择" size="small" @change="onGetScore">
                                                <el-option
                                                v-for="item in dbcs_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                            </el-row>
                            <el-row v-if="newObj">
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">信用状况</td>
                        <td colspan="2">还款能力</td>
                        <td colspan="2">担保措施</td>
                        <td colspan="2">额外分：</td>
                        <td colspan="2">最终得分</td>
                        <td colspan="2">预授信(万元）</td>
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ newObj.Score1 }}</td>
                        <td colspan="2">{{ newObj.Score2 }}</td>
                        <td colspan="2">{{ newObj.Score3 }}</td>
                        <td colspan="2">{{ newObj.Score4 }}</td>
                        <td colspan="2">{{ newObj.Score }}</td>
                        <td colspan="2">{{ newObj.PreCredit }}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                            </el-row>
                        <el-row v-if="contractObj">
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    推荐函/担保函下载
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-if="contractObj">
                            <el-col :span="24">
                                <div v-if="contractObj" class="bankAuditContent" style="text-align: center;"> 
                                    <el-button v-if="contractObj&&contractObj.HTType===1" size="small" type="success" icon="el-icon-download" @click="onDownChange(contractObj.WordPath)">下载推荐函</el-button>
                                    <el-button v-if="contractObj&&contractObj.HTType===2" size="small" type="success" icon="el-icon-download" @click="onDownChange(contractObj.WordPath)">下载担保函</el-button>
                                </div>
                                <div v-else class="bankAuditContent" style="text-align: center;"> 
                                    无推荐函和担保函
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    确认信息
                                </div>
                            </el-col>
                        </el-row>
                            <el-form :rules="rules" ref="ruleForm" style="width:100%" :model="flowInfo">
                                <el-row>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">最终贷款金额(万元)：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent" style="padding-top:10px;"> 
                                            <el-form-item prop="FinalMoney">
                                                <el-input
                                                    v-model.number="flowInfo.FinalMoney"
                                                    size="small"
                                                    placeholder="请输入最终贷款金额(万元)">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保函年份：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent" style="padding-top:10px;"> 
                                            <el-form-item  prop="LoanYear" >
                                                <el-input
                                                    v-model.number="flowInfo.LoanYear"
                                                    size="small"
                                                    placeholder="请输入担保函年份">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保函序号：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent" style="padding-top:10px;"> 
                                            <el-form-item prop="LoanTime">
                                                <el-input
                                                    v-model="flowInfo.LoanTime"
                                                    size="small"
                                                    placeholder="请输入担保函序号">
                                                </el-input>
                                            </el-form-item>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">委托担保合同号：</div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditContent" style="padding-top:10px;">
                                                <el-form-item prop="EntrustedGuarantee">
                                                    <el-input
                                                        v-model="flowInfo.EntrustedGuarantee"
                                                        size="small"
                                                        placeholder="请输入委托担保合同号">
                                                    </el-input>
                                                </el-form-item> 
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-form>

                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditOperate">
                                    <el-button size="small"  @click="hanget">担保函生成</el-button>
                                    <el-button size="small" type="danger" @click="onReturnFlow">拒绝</el-button>
                                    <el-button size="small" type="success" @click="onPassFlow">通过</el-button>
                                </div>
                            </el-col>
                        </el-row>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="进度信息" name="first" v-if="!auditShow">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <!-- <el-row style="background-color:#fff">
                            <el-col :span="24" style="padding:20px">
                                <el-steps :active="stepsStatus" align-center :process-status="errorflag==true ? 'error':'process'">
                                    <el-step title="线上申请" :description="flowInfo.CreateTime"></el-step>
                                    <el-step title="担保部长审核" :description="flowInfo.SecondTime"></el-step>
                                    <el-step title="银行确认" :description="flowInfo.ThirdTime"></el-step>
                                </el-steps>
                            </el-col>
                        </el-row> -->
                        <el-row>
                            <el-col :span="24">
                                <div style="margin-top:20px;font-weight:bold">
                                    用户申请信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">姓名：{{flowInfo.Name}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">身份证号：{{flowInfo.IdNum}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">联系方式：{{flowInfo.Phone}}</div>
                            </el-col>
                            <el-col :span="8" >
                                <div class="viewText">申请者：{{flowInfo.PersonCompanyFlag
                                =='company'?"公司":"个人"}}</div>
                            </el-col>
                            <el-col :span="8" v-if="flowInfo.PersonCompanyFlag==='company'">
                                <div class="viewText">公司名称：{{flowInfo.PersonCompanyText}}</div>
                            </el-col>
                            <el-col :span="8" v-if="flowInfo.PersonCompanyFlag==='company'">
                                <div class="viewText">营业执照：{{flowInfo.PersonCompanyKey}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">申请金额：{{flowInfo.Money}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">银行：{{flowInfo.FullBankChooseText}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">申请时间：{{flowInfo.CreateTime}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">主营业务：{{flowInfo.FirstBusiness}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">{{secondBusinessTitle}}：{{flowInfo.SecondBusiness}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">类型：{{flowInfo.LoanName}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">资产总额：{{flowInfo.TotalAssets}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">资产负债率：{{flowInfo.AssetCoverage}}%</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年营业收入：{{flowInfo.LastYearIncome}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年税收：{{flowInfo.LastYearTax}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">上年利润：{{flowInfo.LastYearProfit}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">从业人数：{{flowInfo.PeopleCount}}人</div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24"  v-if="flowInfo.State>1">
                                <div style="margin-top:20px;font-weight:bold">
                                    担保审核信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow"  v-if="flowInfo.State>1">
                                    <el-col :span="8">
                                <div class="viewText">最终贷款金额：{{flowInfo.FinalMoney}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">担保函年份：{{flowInfo.LoanYear}}</div>
                            </el-col>
                                <el-col :span="8">
                                <div class="viewText">担保函序号：{{flowInfo.LoanTime}}万元</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">委托担保合同号:{{flowInfo.EntrustedGuarantee}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">审核人：{{flowInfo.SecondUserName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">审核时间：{{flowInfo.SecondTime}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">结果：{{ flowInfo.State==3?'拒绝':'通过' }}</div>
                            </el-col>
                            <el-col :span="24" v-if="flowInfo.State==3">
                                <div class="viewText">拒绝原因：{{flowInfo.RefuseReason}}</div>
                            </el-col>
                            <el-col :span="8" v-if="contractObj">
                                    <el-button v-if="contractObj&&contractObj.HTType==1" size="small" type="success" icon="el-icon-download" @click="onDownChange(contractObj.WordPath)">下载推荐函</el-button>
                                    <el-button v-if="contractObj&&contractObj.HTType==2" size="small" type="success" icon="el-icon-download" @click="onDownChange(contractObj.WordPath)">下载担保函</el-button>
                            </el-col>
                            
                        </el-row>
                        <el-row v-if="flowInfo.State>3">
                            <el-col :span="24">
                                <div style="margin-top:20px;font-weight:bold">
                                    银行审核信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow"  v-if="flowInfo.State>3">
                            <el-col :span="8">
                                <div class="viewText">审核人：{{flowInfo.ThirdUserName}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">审核时间：{{flowInfo.ThirdTime}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">结果：：{{ flowInfo.State==5?'拒绝':'通过' }}</div>
                            </el-col>
                            <el-col :span="24" v-if="flowInfo.State==5">
                                <div class="viewText">拒绝原因：{{flowInfo.RefuseReason}}</div>
                            </el-col>
                        </el-row>
                    </el-scrollbar>


                </el-tab-pane>
                <el-tab-pane label="身份信息" name="third">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row class="viewRow">
                            <el-col :span="8">
                                <div class="viewText">姓名：{{flowInfo.Name}}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="viewText">身份证号：{{flowInfo.IdNum}}</div>
                            </el-col>
                        </el-row>
                        <el-row class="viewRow">
                            <el-col :span="2">
                                <div class="viewText">身份证正反面:</div>
                            </el-col>
                        <el-col :span="8">
                                <img style="width: 100%;padding: 5%;" :src="flowInfo.FrontImg"/>
                        </el-col>
                        <el-col :span="2"></el-col>
                        <el-col :span="8">
                                <img style="width: 100%;padding: 5%;" :src="flowInfo.BackImg"/>
                        </el-col>
                        <el-col :span="4"></el-col>

                    </el-row>
                    </el-scrollbar>
                </el-tab-pane>
                <el-tab-pane label="预授信信息" name="four">
                    <el-scrollbar :height="scrollHeight" :noresize="true">
                        <el-row>
                            <el-col :span="24">
                                <div class="bankAuditTitle">
                                    <div class="bankAuditSplit"></div>
                                    农业信息
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-if="llTableData.length==0">
                            <el-col :span="24">
                                <div class="bankAuditFileList">
                                    无
                                </div>
                            </el-col>
                        </el-row>
                        <el-row v-else>
                            <el-col :span="24">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="4">权证流水号</td>
                        <td colspan="4">发包方名称</td>
                        <td colspan="4">承包方期限</td>
                        <td colspan="2">承包方名称</td>
                        <td colspan="2">地块面积</td>
                        <td colspan="2">地块总数</td>
                        <td colspan="3">土地类型</td>
                        <td colspan="3">土地用途</td>
                        </tr>
                    <tr v-for="(abc,i) in llTableData">
                            <td colspan="4">{{abc.QZLSH}}</td>
                            <td colspan="4">{{abc.FBFMC}}</td>
                            <td colspan="4">{{abc.CBQXQ}}至{{abc.CBQXZ}}</td>
                            <td colspan="2">{{abc.name}}</td>
                            <td colspan="2">{{abc.area}}</td>
                            <td colspan="2">{{abc.num}}</td>
                            <td colspan="3">{{abc.TDLYLX}}</td>
                            <td colspan="3">{{abc.TDYT}}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                        </el-row>
                        <!-- <el-row v-if="llTableData.length>0">
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">年龄</td>
                        <td colspan="2">面积(亩)</td>
                        <td colspan="2">预授信</td>
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ areascorelist[0]}}</td>
                        <td colspan="2">{{ areascorelist[1] }}</td>
                        <td colspan="2">{{ areascorelist[2] }}</td>
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                            </el-row> -->
                          <el-row>
                                <el-col :span="24">
                                    <div class="bankAuditTitle">
                                        <div class="bankAuditSplit"></div>
                                        历史信用评分
                                    </div>
                                </el-col>
                            </el-row>
                            <template v-if=" loanAudit.PreCredit">
                                <el-row>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">资产总额（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.TotalAssets"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                    <div class="bankAuditLB">资产负债率（%）：</div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="bankAuditContent"> 
                                        <el-input
                                            disabled
                                            v-model="loanAudit.AssetCoverage"
                                            size="small">
                                        </el-input>
                                    </div>
                                </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年营业收入（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                                disabled
                                                v-model="loanAudit.LastYearIncome"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年利润（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                               disabled
                                                v-model="loanAudit.LastYearProfit"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">上年税收（万元）：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.loanAudit"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">从业人数：</div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="bankAuditContent"> 
                                            <el-input
                                            disabled
                                                v-model="loanAudit.PeopleCount"
                                                size="small">
                                            </el-input>
                                        </div>
                                    </el-col>
                                    <el-col :span="1"></el-col>
                            </el-row>
                             <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">征信记录：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.xyzk_value1" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in xyzk_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">征信查询:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value2" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in xyzk_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">诉讼及执行情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent">  
                                            <el-select  disabled v-model="loanAudit.xyzk_value3" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in xyzk_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">借款人稳定性：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value4" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in xyzk_list4"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">企业经营情况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.xyzk_value5" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in xyzk_list5"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                             </el-row>
                             <el-row>
                                <el-col :span="3">
                                        <div class="bankAuditLB">财务状况：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select  disabled v-model="loanAudit.hknl_value1" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in hknl_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">收入及现金流:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value2" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in hknl_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">抵押物价值：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.hknl_value3" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in hknl_list3"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                             </el-row>
                             <el-row style="margin-top: 12px;">
                                <el-col :span="3">
                                        <div class="bankAuditLB">担保人信用及能力：</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value1" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in dbcs_list1"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                                    <el-col :span="3">
                                        <div class="bankAuditLB">担保方式及风险:</div>
                                    </el-col>
                                <el-col :span="5">
                                        <div class="bankAuditContent"> 
                                            <el-select disabled v-model="loanAudit.dbcs_value2" placeholder="请选择" size="small">
                                                <el-option
                                                v-for="item in dbcs_list2"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </el-col>
                             </el-row>
                             <el-row>
                                <el-col :span="7"></el-col>
                                <el-col :span="10">
                                <div class="bankAuditInfoTable">
                                    <table class="bg-table" border="1" bordercolor="#4e717d">
                        <tr style="font-weight: bold;">
                        <td colspan="2">信用状况</td>
                        <td colspan="2">还款能力</td>
                        <td colspan="2">担保措施</td>
                        <td colspan="2">额外分：</td>
                        <td colspan="2">最终得分</td>
                        <td colspan="2">预授信(万元）</td>
                        <!-- <td colspan="2">操作人</td>
                        <td colspan="2">时间</td> -->
                        </tr>
                        <tr style="font-weight: bold;">
                        <td colspan="2">{{ loanAudit.Score1 }}</td>
                        <td colspan="2">{{ loanAudit.Score2 }}</td>
                        <td colspan="2">{{ loanAudit.Score3 }}</td>
                        <td colspan="2">{{loanAudit.Score4}}</td>
                        <td colspan="2">{{ loanAudit.Score}}</td>
                        <td colspan="2">{{ loanAudit.PreCredit}}</td>
                        <!-- <td colspan="2">{{ loanAudit.UpdateUserName}}</td>
                        <td colspan="2">{{ loanAudit.UpdateTime}}</td> -->
                        </tr>
                      </table> 
                                </div>
                            </el-col>
                             </el-row>
                            </template>
                            <el-row v-if="!loanAudit.PreCredit">
                            <el-col :span="24">
                                <div class="bankAuditFileList">
                                    无
                                </div>
                            </el-col>
                        </el-row>
                    </el-scrollbar>

                </el-tab-pane>
                <el-tab-pane label="推荐函" name="five" v-if="hanShow">
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractCode"><el-input  v-model="model.Hjhbh" placeholder="" style="width:350px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractTitle">推荐函</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFrom"><el-input v-model="model.Title" placeholder="" style="width:500px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractContent2">为进一步推动农业信贷服务体系创新,有效缓解我市新型农业经营主体和服务主体“融资难、融资贵”,根据湖北省农业信贷融资担保有限公司与枝江市人民政府合作协议,经枝江市天雨农业融资担保有限公司审核评审、以下借款人符合基本准入条件，同意向省农业信贷担保有限公司推荐,续贷担保金额以贷款结清后重新出具推荐函为准。请予接洽办理。</div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">借款人名称:</label><div class="LoanContractContent"><el-input v-model="model.Jkrmc" placeholder="" style="width:400px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">借款人(或法人）:</label><div class="LoanContractContent"><el-input v-model="model.Jkr" placeholder="" style="width:100px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">身份证号:</label><div class="LoanContractContent"><el-input v-model="model.Sfzh" placeholder="" style="width:250px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">推荐金额:{{model.Tjjedx}}万元（￥</label><div class="LoanContractContent"><el-input v-model="model.Tjje" placeholder="" style="width:80px;" @change="onMoneyChange"></el-input>万元)</div>
                        </el-col>
                        <el-col :span="24">
                            <label class="LoanContractLb">期限:</label><div class="LoanContractContent"><el-input v-model="model.Qx" placeholder="" style="width:80px;"></el-input>月</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractSplit"></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">枝江市天雨农业融资担保有限公司</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">
                                <el-date-picker
                                    value-format="YYYY-MM-DD"
                                    v-model="model.Sj"
                                    format="YYYY年MM月DD日"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractOperate">
                                <el-button size="medium" type="info" @click="onExportWord(1)">导出预览推荐函</el-button>
                                <el-button size="medium" type="success" @click="onSubmit(1)">确认生成担保函</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane label="担保函" name="six" v-if="hanShow">
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractCode"><el-input v-model="model2.Hjhbh" placeholder="" style="width:350px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractTitle">担保函</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFrom"><el-input v-model="model2.Title" placeholder="" style="width:500px;"></el-input></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractContent2">根据<el-input v-model="model2.Jkrmc" placeholder="" style="width:300px;text-indent:0px;"></el-input>提出的担保贷款申请,经我公司调查、评审并与贷款人办妥相关手续,枝江市天雨农业融资担保有限公司同意为该经营主体进行担保,担保贷款金额人民币{{model2.Tjjedx}}万元（￥:<el-input v-model="model2.Tjje" placeholder="" style="width:80px;text-indent:0px;" @change="onMoneyChange2"></el-input>万元）,期限<el-input v-model="model2.Qx" placeholder="" style="width:80px;text-indent:0px;"></el-input>个月（具体时间以借款凭证为准),请贵行为借款人发放贷款。</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractSplit"></div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">枝江市天雨农业融资担保有限公司</div>
                        </el-col>
                        <el-col :span="24">
                            <div class="LoanContractFooter">
                                <el-date-picker
                                    value-format="YYYY-MM-DD"
                                    v-model="model2.Sj"
                                    format="YYYY年MM月DD日"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="LoanContractOperate">
                                <el-button size="medium" type="info" @click="onExportWord(2)">导出预览担保函</el-button>
                                <el-button size="medium" type="success" @click="onSubmit(2)">确认生成担保函</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import indexJs from "./index.js";

    export default indexJs;
</script>

<style>
    @import url(./assets/style/style.less);

    .viewText {
        text-indent: 20px;
        height: 30px;
        line-height: 30px;
        padding: 15px 0px;
        text-align: left;
    }

    .viewRow {
        margin-left: 5%;
        width: 90%;
    }
</style>
